RivalIQ.apps.LandscapeSettings.module('controller', function (controller, App, Backbone, Marionette, $, _) {

    'use strict';

    const Router = Marionette.AppRouter.extend({
        appRoutes: {
            ':tab': 'setActiveTab',
            '*path': 'setLandscapeSettingsTab'
        }
    });

    const Controller = Marionette.Controller.extend({
        initialize: function (options) {
            const me = this;

            const opts = {
                email: RivalIQ.state.user.get('email'),
                landscapeEmails: RivalIQ.apps.LandscapeSettings.collections.Email.createFromSettings(RivalIQ.state.landscape.get('emailSettings')),
                canCustomizeBranding: RivalIQ.state.account.get('plan').has_white_label,
                title: 'Landscape Settings',
                subtitle: RivalIQ.state.view.get('landscapeName'),
                settings: App.data.emailSettings
            };

            me.options = _.extend(opts, options);
            RivalIQ.apps.Shell.execute('set:navigation', {
                page: RivalIQ.configuration.menus.getConfiguration().LANDSCAPE_SETTINGS
            });

            RivalIQ.apps.Shell.execute('set:title', opts.title);

        },
        start: function () {

            const me = this;
            const options = me.options;

            me.showGeneral(options);
            me.showEmail(options);

            if (options.canCustomizeBranding) {
                me.showBranding(options);
            }

            $('.x-customize-branding').removeClass('hide');
        },
        showGeneral: function () {

            const mask = RivalIQ.enums.sourceMask;
            const requiredMask = mask.TWITTER | mask.FACEBOOK | mask.YOUTUBE | mask.INSTAGRAM | mask.TIKTOK;
            const hideable = _.values(RivalIQ.enums.hideableSourceDescriptions);

            const general = new RivalIQ.apps.LandscapeSettings.views.General({
                model: new RivalIQ.models.Landscape(),
                collection: new Backbone.Collection(hideable),
                requiredMask: requiredMask
            });

            App.general.show(general);
        },
        showEmail: function (options) {
            const filteredOptions = _.clone(options);
            filteredOptions.settings.models = _.reject(options.settings.models, function (model) {
                return model.attributes.dashboardEmailTypeId === RivalIQ.enums.email.type.seoKeywords;
            });

            const tab = new App.views.EmailTab(filteredOptions);
            App.email.show(tab);
        },
        showBranding: function () {

            App.branding.show(new App.views.Branding({
                collection: RivalIQ.state.branding
            }));
        },
        setLandscapeSettingsTab: function () {
            const me = this;
            me.setActiveTab('actionsTab');
        },
        setActiveTab: function (tab) {
            // NOTE work around mandrill misbehavior, where it appends query parameters after the hash, instead of before;
            // see #5285
            tab = tab.split('&')[0];

            if (tab === 'notifications') {

                tab = 'emailTab';
            }

            $('#secondaryNav li').each(function () {

                const li = $(this);

                if (li.hasClass('active') || li.hasClass('current')) {

                    li.removeClass('active').removeClass('current');
                }
            });

            $(`a[href="#${tab}"]`).tab('show');

            const metric = ({
                actionsTab: RivalIQ.tracking.metric.V3ViewedLandscapeSettings,
                emailTab: RivalIQ.tracking.metric.V3ViewedLandscapeNotificationSettings,
                themeTab: RivalIQ.tracking.metric.ViewedLandscapeBrandingSettings
            }[tab]);

            if (metric) {
                RivalIQ.execute('tracking:push:auth', metric);
            }
        }
    });

    App.on('before:start', function (options) {
        const controller = new Controller(options);
        new Router({
            controller: controller
        });
        controller.start();
    });
});
